"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Image = require("../Image");
var _S3PrivateImage = require("../S3PrivateImage");
var _theme = require("../utils/theme");
var _ExpansiveCard = require("./ExpansiveCard.styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ExpansiveCard = function ExpansiveCard(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    children = _ref.children,
    image = _ref.image,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? true : _ref$isExpanded,
    prefixIcon = _ref.prefixIcon,
    previewContent = _ref.previewContent,
    s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket,
    subtitle = _ref.subtitle,
    title = _ref.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    viewMoreActive = _useState2[0],
    setViewMoreActive = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ExpansiveCardContainer, {
    theme: theme,
    hasImage: image || s3Key && s3Bucket
  }, image && /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ImageContainer, null, /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    className: "imageContainer",
    src: image
  })), s3Key && s3Bucket && /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ImageContainer, null, /*#__PURE__*/_react["default"].createElement(_S3PrivateImage.S3PrivateImage, {
    className: "imageContainer",
    s3Key: s3Key,
    s3Bucket: s3Bucket
  })), !image && !s3Key && !s3Bucket && /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.PreviewContent, null, previewContent), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '16px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ExpansiveCardHeader, null, prefixIcon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    size: 20,
    icon: prefixIcon,
    style: {
      marginRight: '8px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.TitleHeader, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ExpansiveCardTitle, {
    weight: "bold",
    type: "subtitle"
  }, title)), /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.TitleHeader, null, actions && actions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: '8px'
      }
    }, action);
  }))), subtitle && /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ExpansiveCardDescriptionTrimmed, {
    type: "small"
  }, subtitle), /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.ExpansiveCardChildren, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: viewMoreActive ? 'collapsed' : 'collapsible'
  }, children)), /*#__PURE__*/_react["default"].createElement(_ExpansiveCard.TitleHeader, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    dense: true,
    outline: true,
    icon: viewMoreActive ? 'dropdown-up' : 'dropdown-down',
    onClick: function onClick() {
      return setViewMoreActive(!viewMoreActive);
    },
    disabled: !isExpanded
  }, "View ", viewMoreActive ? 'Less' : 'More'))));
};
var _default = exports["default"] = ExpansiveCard;